import React from 'react';
import pt from 'prop-types';
import Link from 'components/link';
import { Field } from 'components/form';

const RECOVER_TO = '/recover';

// Opens in its own tab, so a half-filled form behind it survives
export function RecoverNote() {
  return (
    <div className="login-note">
      <span className="forgot-password">Forgot your password? </span>
      <Link to={RECOVER_TO} target="blank" className="recover-password">
        Recover
      </Link>
    </div>
  );
}

const FIELD = 'login-form-field-margin-16';
const FIELD_LAST = 'login-form-field-margin-24';
const FIELD_LEFT = `span2 login-form-field-padding-right-8 ${FIELD}`;
const FIELD_RIGHT = `span2 login-form-field-padding-left-8 ${FIELD}`;

export function CreateAccountFields({ defaultName, defaultEmail }) {
  return (
    <fieldset>
      <div className="row">
        <Field
          label="First name"
          type="text"
          name="first_name"
          defaultValue={defaultName}
          required={true}
          autoCompleteOff={true}
          large={true}
          validateIcon={true}
          validateBlur={true}
          className={FIELD_LEFT}
        />
        <Field
          label="Last name"
          type="text"
          name="last_name"
          defaultValue={defaultName}
          required={true}
          autoCompleteOff={true}
          large={true}
          validateIcon={true}
          validateBlur={true}
          className={FIELD_RIGHT}
        />
      </div>
      <Field
        label="Email"
        type="text"
        name="email"
        defaultValue={defaultEmail}
        rules="required, email"
        autoCompleteOff={true}
        large={true}
        validateIcon={true}
        validateBlur={true}
        className={FIELD}
      />
      <input
        type="password"
        name="password"
        className="hidden"
        defaultValue=""
      />
      <Field
        label="Create a password"
        type="password"
        name="password"
        rules="required, password_admin"
        autoComplete="new-password"
        large={true}
        validateIcon={true}
        validateBlur={true}
        className={FIELD_LAST}
      />
    </fieldset>
  );
}

CreateAccountFields.propTypes = {
  defaultName: pt.string,
  defaultEmail: pt.string,
};

// `showRecover` is off where the screen renders the note after its own submit
export function SignInFields({ defaultEmail, showRecover = true }) {
  return (
    <fieldset>
      <Field
        label="Email"
        type="text"
        name="email"
        defaultValue={defaultEmail}
        rules="required, email"
        large={true}
        validateIcon={true}
        validateBlur={true}
        className={FIELD}
      />
      <Field
        label="Password"
        type="password"
        name="password"
        rules="required"
        large={true}
        validateIcon={true}
        validateBlur={true}
        className={FIELD_LAST}
      />
      {showRecover && <RecoverNote />}
    </fieldset>
  );
}

SignInFields.propTypes = {
  defaultEmail: pt.string,
  showRecover: pt.bool,
};
